const formatCertificateFileName = (certificateFileName, certificateSubject) => {

    if (!certificateFileName) {
        
        return;
    }

    const subject = certificateSubject ? ' (' + certificateSubject+ ')' : '';

    return `${certificateFileName} ${subject}`;
};

export { formatCertificateFileName };